import { useQuery } from "@apollo/client/react";
import { useMemo } from "react";

import { ScanProvider } from "types/generated";

import { GET_SCAN_FORM_OPTIONS } from "./gql";

const useScanFormOptions = (spaceId: string | undefined) => {
  const { data, error, loading, refetch } = useQuery(GET_SCAN_FORM_OPTIONS, {
    variables: { provider: ScanProvider.Aws, spaceId: spaceId ?? "" },
    skip: !spaceId,
  });

  const schema = data?.scanProviderSchemas[0];

  const integrations = useMemo(
    () =>
      (data?.attachableAwsIntegrationsInSpace ?? []).filter((integration) => !integration.legacy),
    [data?.attachableAwsIntegrationsInSpace]
  );

  return {
    providerVersions: schema?.majorVersions ?? [],
    regions: schema?.configSchema.regions ?? [],
    resourceTypes: schema?.resourceTypes ?? [],
    integrations,
    workerPools: data?.attachableWorkerPoolsInSpace ?? [],
    error,
    loading,
    refetch,
  };
};

export default useScanFormOptions;
